export const INTRO = 0;
export const ROLE_QUESTION_STEP = 1;
export const SOFTWARE_QUESTION_STEP = 2;
export const EXPERIENCE_QUESTION_STEP = 3;

export const HOW_INQUIRY_STEP = 4;

export const FIRST_STEP = INTRO;

export const ROLE_QUESTION_PROMPT = 'What best describes your role in VFX?';
export const ROLE_QUESTION_ANSWER_1 = "VFX Supervisor"
export const ROLE_QUESTION_ANSWER_2 = 'Compositor';
export const ROLE_QUESTION_ANSWER_3 = 'FX Artist';
export const ROLE_QUESTION_ANSWER_4 = 'Motion Designer';
export const ROLE_QUESTION_ANSWER_5 = '3D Generalist';
export const ROLE_QUESTION_ANSWER_6 = 'Editor';
export const ROLE_QUESTION_ANSWER_7 = 'Creative Director';
export const ROLE_QUESTION_ANSWER_8 = 'Producer';
export const ROLE_QUESTION_ANSWER_9 = 'Content Creator';
export const ROLE_QUESTION_ANSWER_10 = 'Hobbyist';
export const ROLE_QUESTION_ANSWER_11 = 'Student';
export const ROLE_QUESTION_ANSWER_12 = 'Animator';
export const ROLE_QUESTION_ANSWER_13 = 'Other';

export const SOFTWARE_QUESTION_PROMPT = 'Which software do you primarily use?';
export const SOFTWARE_QUESTION_ANSWER_1 = 'Maya';
export const SOFTWARE_QUESTION_ANSWER_2 = 'Flame';
export const SOFTWARE_QUESTION_ANSWER_3 = 'Fusion';
export const SOFTWARE_QUESTION_ANSWER_4 = 'Blender';
export const SOFTWARE_QUESTION_ANSWER_5 = 'Unreal Engine';
export const SOFTWARE_QUESTION_ANSWER_6 = 'Houdini';
export const SOFTWARE_QUESTION_ANSWER_7 = 'Cinema4D';
export const SOFTWARE_QUESTION_ANSWER_8 = 'Nuke';
export const SOFTWARE_QUESTION_ANSWER_9 = 'Unity';
export const SOFTWARE_QUESTION_ANSWER_10 = 'Mari';
export const SOFTWARE_QUESTION_ANSWER_11 = 'Arnold';
export const SOFTWARE_QUESTION_ANSWER_12 = 'AfterEffects';
export const SOFTWARE_QUESTION_ANSWER_13 = 'Embergen';
export const SOFTWARE_QUESTION_ANSWER_14 = 'Other';

export const EXPERIENCE_QUESTION_PROMPT = 'Years of Experience';
export const EXPERIENCE_QUESTION_ANSWER_1 = 'Less than 1';
export const EXPERIENCE_QUESTION_ANSWER_2 = "1-5"
export const EXPERIENCE_QUESTION_ANSWER_3 = "5-10"
export const EXPERIENCE_QUESTION_ANSWER_4 = "10+"

export const HOW_INQUIRY_PROMPT = 'How did you hear about ActionVFX?';
export const HOW_INQUIRY_ANSWER_1 = 'Friend/Colleague';
export const HOW_INQUIRY_ANSWER_2 = 'Web Search';
export const HOW_INQUIRY_ANSWER_3 = 'Online Advertising';
export const HOW_INQUIRY_ANSWER_4 = 'YouTube';
export const HOW_INQUIRY_ANSWER_5 = 'Instagram';
export const HOW_INQUIRY_ANSWER_6 = 'Facebook';
export const HOW_INQUIRY_ANSWER_7 = 'Threads';
export const HOW_INQUIRY_ANSWER_8 = 'TikTok';
export const HOW_INQUIRY_ANSWER_9 = 'Twitter/X';
export const HOW_INQUIRY_ANSWER_10 = 'Other';